import { Post } from '@/features/help-center/types/post'
import { CardTitle } from '@/shared/ui/Card'

interface PostCardProps {
  post: Post
  onClick: () => void
}

export const PostCard = ({ post, onClick }: PostCardProps) => {
  return (
    <CardTitle
      className="bg-linear-to-t from-[#E4E8FA] to-[#DDD4FF] py-3 px-4 rounded-lg flex flex-col items-start cursor-pointer hover:shadow-[0_2px_0_0_#C7BFFF] transition-all duration-100"
      onClick={onClick}
    >
      <span className="text-md text-primary-dark block font-semibold font-sans mb-1">
        {post.name}
      </span>
      {!!post?.description && (
        <p className="text-sm text-start font-normal line-clamp-3 text-american-blue">
          {post.description}
        </p>
      )}
    </CardTitle>
  )
}
